export default `
  query getWorkflow($workflowId: String!, $projectId: String!) {
    getWorkflow(workflowId: $workflowId, projectId: $projectId) {
      id
      projectId
      name
      version
      createdAt
      updatedAt
      thumbnail
      teamMembers {
        userId
      }
      status
    }
  }
`
